import { Button } from 'antd'
import styled from 'styled-components'

const StyledButtonWithMargin = styled(Button)`
  margin-right: 8px;
`

export default StyledButtonWithMargin
